(() => {
  if (customElements.get('nn-naked-bundles')) return;
  customElements.define('nn-naked-bundles', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = new AbortController();
      const schedule = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.alignCards());
      };
      this.width = undefined;
      this.observer = new ResizeObserver(entries => {
        const width = entries[0].contentRect.width;
        if (width !== this.width) {
          this.width = width;
          schedule();
        }
      });
      this.observer.observe(this);
      document.fonts?.ready.then(() => { if (this.isConnected) schedule(); });
      document.fonts?.addEventListener('loadingdone', schedule, { signal:this.controller.signal });
      schedule();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
    }
    alignCards() {
      const grid = this.querySelector('.nl-bundles__grid');
      if (!grid || !grid.getClientRects().length) return;
      const cards = [...grid.children];
      const slots = [
        ['occasion', '.nl-bundle-card__occasion'],
        ['title', '.product-card__title, .nl-bundle-card__body h3'],
        ['price', '.product-card__price-slot, .nl-bundle-card__status'],
        ['info', '.product-card__info, .nl-bundle-card__body'],
        ['benefit', '.nl-bundle-card__benefit']
      ];
      cards.forEach(card => slots.forEach(([name]) => card.style.removeProperty(`--nl-bundle-${name}-height`)));
      const rows = new Map();
      cards.forEach(card => {
        const top = Math.round(card.getBoundingClientRect().top);
        if (!rows.has(top)) rows.set(top, []);
        rows.get(top).push(card);
      });
      rows.forEach(row => slots.forEach(([name, selector]) => {
        const height = Math.max(...row.map(card => card.querySelector(selector)?.getBoundingClientRect().height || 0));
        row.forEach(card => card.style.setProperty(`--nl-bundle-${name}-height`, `${height}px`));
      }));
    }
  });
})();
